"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Chunk the given array into pieces of given size.
 *
 * @Param {Array} array = The array to slice.
 * @Param {Number} size = The size of the chunks.
 *
 * Example:
 *   chunk(['Pizza', 'Pineapple', 'Apple', 'Pasta'], 2)
 *   //=> [['Pizza', 'Pineapple'], ['Apple', 'Pasta']]
 */
function chunk(array, size) {
    return array.reduce(([chunks, takeFrom]) => {
        if (takeFrom.length === 0) {
            return [chunks, takeFrom];
        }
        return [[...chunks, takeFrom.slice(0, size)], takeFrom.slice(size)];
    }, [[], array])[0];
}
exports.chunk = chunk;
//# sourceMappingURL=chunk.js.map